import React from 'react';
import './btnStyle.scss';

const GroupCommonButton = ({ buttons = [] }) => {
  return (
    <div className="btn-group col-md-12" role="group" aria-label="Outlined button group">
    {buttons.map((btn, index) => (
      <button
        key={index}
        type="button"
        className={`btn btn-outline-primary`}
        onClick={btn.onClick}
        disabled={btn.disabled}
      >
        {btn.label}
      </button>
    ))}
  </div>
  );
};

export default GroupCommonButton;
